import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { cardWeekList } from 'lib/api/script';
import { tableHeaders } from 'lib/api/common';
import { makeHeadData, makeRowColumn, getHeadObj } from 'lib/commonLib';

import NewTableContainer from 'components/molecules/NewTable';
import SwitchingArea from 'components/organisms/SwitchingArea';

const Statistics = (props) => {
  const { handleLoading, handleClickSnackbar } = props;
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [monthHead, setMonthHead] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [weekHead, setWeekHead] = useState([]);
  const [weekList, setWeekList] = useState([]);

  useEffect(() => {
    tableHeaders({ uri: '/script/weekStatistics' }).then((response) => {
      setWeekHead(response.data.data);
    });
    tableHeaders({ uri: '/script/monthStatistics' }).then((response) => {
      setMonthHead(response.data.data);
    });
    cardWeekList()
      .then((response) => {
        setWeekList(response.data.data.week);
        setMonthList(response.data.data.month);
        setLoading(false);
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: { type: 'error' },
        });
      })
      .then(() => {
        handleLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  const customized = {
    common: {
      SCRIPT_SCRIPT_COUNT: { headStyle: { width: 100 } },
      SCRIPT_INSITE_COUNT: { headStyle: { width: 100 } },
    },
    month: {
      SCRIPT_MONTH_DATE: { headStyle: { width: 100 } },
    },
    week: {
      SCRIPT_WEEK_DATE: { headStyle: { width: 100 } },
      SCRIPT_START_DATE: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem = getHeadObj(headsMap, 'SCRIPT_START_DATE');
          return !!rowObj['isTotal']
            ? ''
            : makeRowColumn(
                rowObj['SCRIPT_START_DATE'],
                bodyItem.type,
                bodyItem.format
              );
        },
        headStyle: { width: 100 },
      },
      SCRIPT_END_DATE: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem = getHeadObj(headsMap, 'SCRIPT_END_DATE');
          return !!rowObj['isTotal']
            ? ''
            : makeRowColumn(
                rowObj['SCRIPT_END_DATE'],
                bodyItem.type,
                bodyItem.format
              );
        },
        headStyle: { width: 100 },
      },
    },
  };

  return (
    <>
      <SwitchingArea title={t('월별 통계')}>
        <NewTableContainer
          dataReqPromise={cardWeekList}
          params={{
            order: 'SCRIPT_MONTH_DATE',
            sort: 'desc',
          }}
          getParam={(f) => f}
          useFetch={false}
          useToolBar={false}
          usePagenation={false}
          rowsPerPage={-1}
          useCustomTable
          propsList={monthList['data']}
          propsTotalList={monthList['total']}
          propsHeadCells={makeHeadData(monthHead)}
          loading={loading}
          customized={{ ...customized['common'], ...customized['month'] }}
        />
      </SwitchingArea>
      <SwitchingArea title={t('주차별 통계')}>
        <NewTableContainer
          dataReqPromise={cardWeekList}
          params={{
            order: 'SCRIPT_WEEK_DATE',
            sort: 'desc',
          }}
          getParam={(f) => f}
          useFetch={false}
          useToolBar={false}
          usePagenation={false}
          rowsPerPage={-1}
          useCustomTable
          propsList={weekList['data']}
          propsTotalList={weekList['total']}
          propsHeadCells={makeHeadData(weekHead)}
          loading={loading}
          customized={{ ...customized['common'], ...customized['week'] }}
        />
      </SwitchingArea>
    </>
  );
};

export default withRouter(Statistics);
